define.alias("ember-power-select/components/power-select", "media/components/power-select");